import store from '../store';
import { vue } from '../main';

export default function instanceNotLoaded({ next, router }) {
  if (store.getters.instanceLoaded) {
    return router.push({ name: 'InstanceManagement' });
  }

  return next();
}
